import actions from "@/store/modules/organisations/organisation-reasons/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-reasons/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
